import styled from '@emotion/styled'
import { Box, Typography } from '@mui/material'

export const RootWrap = styled(Box)(`
    width: 100%;
    padding: 15px;
    display: flex;
    flex-direction: column;
    border-radius: 8px;
    max-width: 280px;
    min-height: 60px;
    border: 1px #E7E7E6 solid;
    padding-left: 50px;
    position: relative;
    margin-bottom:8px;

    & .breaker {
        width:100% !important;
        height:1px;
        
    }
`)

export const PrimaryText = styled(Typography)(`
    font-size: 16px;
`)

export const SecondaryText = styled(Typography)(`
    font-size: 13px;
    margin-top:-5px;
`)

export const Img = styled(Box)(`
    position: absolute;
    left: 15px;
    top: 15px;
    z-index: 1;
    height: 38px; 
    display: flex;
    align-items: center;
`)


